<div class="occurrences-count" data-test="occurrences-count" (click)="openOccurrencesDialog()">{{ value }}</div>
